import { PriceFilterPipe } from "app/shared/slider.pipe";

export interface Filter {
  value: any;
  path: string;
  values: string[];
  entityKey: string;
  isPeriodFilter?: boolean; // Opcional para filtros de período
}

export function filterDynamic(
  result: any[],
  filters: Filter[],
  lowPrice: any,
  highPrice: any,
  categoryId: any,
  sliderPipe: PriceFilterPipe
): any[] {
  if(result && result.length > 1) {
    result = sliderPipe.transform(result, lowPrice, highPrice, categoryId);
  }

  if (!filters || filters.length === 0) {
    return result || [];
  }

  return filters.reduce((filtered, filter) => {
    if (!filtered || !Array.isArray(filtered)) {
      return [];
    }

    if (filtered.length === 0) {
      return [];
    }

    // Si es filtro de sessions por período, usar lógica especial
    if (filter.path === 'sessions' && filter.isPeriodFilter) {
      return filtered.filter(item => {
        if (!item) return false;

        const nestedArray = getNestedValueSafe(item, filter.entityKey) || [];

        return nestedArray.some(entityItem => {
          const sessionValue = getNestedValueSafe(entityItem, filter.path);
          if (!sessionValue) return false;

          const sessions = Array.isArray(sessionValue) ? sessionValue : [sessionValue];

          return sessions.some(session => {
            const sessionPeriod = getTimePeriod(session.toString());
            return sessionPeriod === filter.values[0]; // El período seleccionado
          });
        });
      });
    } else {
      // Lógica original para otros filtros
      const filteredResult = filtered.filter(item => {
        if (!item) return false;

        const nestedArray = getNestedValueSafe(item, filter.entityKey) || [];

        return nestedArray.some(entityItem => {
          const value = filter.path.split('.').reduce((obj, key) => obj?.[key], entityItem);
          return value && filter.values.includes(value.toString().toLowerCase());
        });
      });

      return filteredResult;
    }

  }, result || []);
}

// Asegúrate de tener getTimePeriod disponible
function getTimePeriod(timeString: string): string {
  try {
    const [hours, minutes] = timeString.split(':').map(part => Number(part.trim()));

    if (isNaN(hours) || isNaN(minutes)) {
      return 'mañana';
    }

    if (hours < 12) {
      return 'mañana';
    } else if (hours < 19) {
      return 'tarde';
    } else {
      return 'noche';
    }
  } catch (error) {
    return 'mañana';
  }
}

function getNestedValueSafe(obj: any, path: string): any {
  if (!obj || !path) return undefined;
  return path.split('.').reduce((current, key) => current?.[key], obj);
}
